import Hero from "@/components/site/Hero";
import { About, ServiceTimes, Ministries, Testimonials } from "@/components/site/Sections";
import { ExploreTiles } from "@/components/site/AboutSections";
import { Newsletter } from "@/components/site/Forms";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Home() {
  usePageMeta(
    "RE//FORM PLACE CHI · A Safe Place to Become. A Strong Place to Belong.",
    "RE//FORM PLACE CHI is a Spirit-filled, apostolic, prophetic church and 501(‌c)(3) nonprofit in Chicago. Sunday Worship 12:30 PM CST. Plan your visit, watch online, give, and connect.",
  );
  return (
    <div data-testid="home-page">
      <Hero />
      <About />
      <ServiceTimes />
      <Ministries />
      <ExploreTiles />
      <Testimonials />
      <Newsletter />
    </div>
  );
}
